import { tw } from '@/utils/tw';
import { default as BaseDirektTheme } from 'base/components/Direkt/theme';

const { Blip } = BaseDirektTheme;

const DirektTheme = tw.theme({
  extend: BaseDirektTheme,
  slots: {
    label: 'text-primary-700',
  },
});

export default Object.assign(DirektTheme, { Blip });
